<template>
  <div class="flex flex-col md:flex-row justify-between items-center mb-5">
    <div class="flex gap-24 w-full justify-between md:justify-start">
      <div class="font-light text-gray-900 dark:text-gold-50">
        {{ carsCount }} bruktbiler
      </div>
      <div class="sortby flex flex-col relative font-light text-gray-900">
        <div class="flex justify-between w-32 text-grey-900 dark:text-gold-50">
          {{ currentSort.translation }}
          <button v-if="currentSort.name !== 'default'" @click="reset">
            <IconClose />
          </button>
          <IconFeather v-else />
        </div>
        <div
          class="options absolute top-8 -left-5 flex flex-col bg-white dark:bg-grey-600 max-h-0 transition-all overflow-hidden"
        >
          <label
            v-for="sort in sortOptions"
            :key="sort.name"
            :class="`bg-white dark:bg-grey-600 pl-5 w-40 py-1 hover:bg-grey-100 dark:hover:bg-grey-500 dark:text-white transition-colors cursor-pointer ${
              sort.name == currentSort.name
                ? 'bg-grey-200 dark:bg-grey-500 pointer-events-none'
                : ''
            }`"
            @click="dataSort = sort"
            v-show="sort.name !== 'default'"
          >
            {{ sort.translation }}
          </label>
        </div>
      </div>
    </div>
    <!-- <div class="whitespace-nowrap">
      <LabbeledCheckbox
        @toggleShowCampaignCars="onToggleShowCampaignCars"
        title="Biler med kampanjerente"
      />
    </div> -->
  </div>
</template>

<script>
import IconFeather from '../partials/IconFeather.vue';
import IconClose from '../partials/IconClose.vue';
import LabbeledCheckbox from '../partials/LabbeledCheckbox.vue';
import sortCarsOptions from '../data/sortCarsOptions';

export default {
  name: 'Sorts',
  emits: ['sortby'],
  data() {
    return {
      dataSort: [],
      showCampaignCars: false,
    };
  },
  props: [
    'currentSort',
    'sortOptions',
    'activeCampaign',
    'carsCount',
    'sortby',
  ],
  watch: {
    dataSort(v) {
      this.$emit('sortby', v);
    },
    showCampaignCars(v) {
      this.$emit('campaign', v);
    },
  },
  components: {
    IconFeather,
    IconClose,
    LabbeledCheckbox,
  },
  methods: {
    reset() {
      this.dataSort = sortCarsOptions[0];
    },
    onToggleShowCampaignCars() {
      this.showCampaignCars = !this.showCampaignCars;
    },
  },
};
</script>
